<template>
    <div>
        <hts-form-select
            v-model="cValue"
            v-model:text="cText"
            :query="findRemooc"
            :filterable="true"
            :clearable="true"
            :label="label"
            :required="required"
            :selected-multiple="dataMultiple"
            :multiple="multiple"
            :prop="prop"
            key-id="_id"
            key-label="licensePlate"
            @change="handleChange" />
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  api: Object,
  modelValue: { type: [Array, String], default: () => '' },
  prop: { type: String, default: '' },
  multiple: { type: Boolean, default: false },
  dataMultiple: { type: [Array, Object], default: () => [] },
  required: { type: Boolean, default: false },
  name: { type: String, default: '' },
  label: { type: String, default: () => $t('labels.remooc') }
})

const emits = defineEmits(['update:modelValue', 'update:name', 'click', 'change'])

const cValue = computed({
  get () {
    return modelValue.value
  },
  set (val: any) {
    emits('update:modelValue', val)
  }
})
const { modelValue, name, required, multiple } = toRefs(props)
const findRemooc = async (s: string) => {
  const api = props.api || $url.vehicle.remooc.find

  const res = await $api(api, { uriParams: { KEY: s } })
  const resData: any = res?.data?.value
  if (resData?.success) {
    return resData.data
  }
  return null
}
const cText = computed({
  get () {
    return name.value || ''
  },
  set (val: any) {
    emits('update:name', val)
  }
})

const handleChange = (val: any) => {
  emits('change', val)
}
</script>
